import {Money} from "./Money.js";

export class MoneyEditingConductor {
	constructor() {
		this.listeners = [];
		this.changeCopiers = [];
		this.discount = { type: "NO" };
		this.vatIncluded = false;
		this.level = 0;
		this.amount = 0;
		this.qty = null;
		/**
		 * @type {?string}
		 */
		this.currency = null;
		/**
		 * @type {Date}
		 */
		this.taxDate = new Date();
		this.query = false;
		this.querySent = false;
		this.nextQuery = null

		this.items = null;	// items money
		this.conversion = null;
	}

	copyAndRecalc() {
		for (let copier of this.changeCopiers) {
			copier();
		}
		this.recalc();
	}

	recalc() {
		if (this.query) {
			var d = this.prepareData();
			if (this.querySent) {
				this.nextQuery = d;
			} else {
				this.queryWith(d);
			}
		}
	}

	queryWith(data) {
		//console.log("QUERY " + JSON.stringify(data));
		this.querySent = true;
		MoneyEditingConductor.postJSON(data)
			.then((result) => {
				this.fireRecalc(result);
				if (this.nextQuery) {
					var nextData = this.nextQuery;
					this.nextQuery = null;
					this.queryWith(nextData);
				} else this.querySent = false;
			})
			.catch((ex) => {
				console.log(ex);
				this.nextQuery = null;
				this.querySent = false;
			});
	}

	/**
	 *	This method prepares JSON data as expected by MoneyCalcData class on the server
	 */
	prepareData() {
		var data = {};
		// Seed money
		data.start = {	// This is received by Money class
			init: true,
			amount: this.amount,
			level: this.level,
			taxDate: DateUtil.formatDate(this.taxDate, false),
			currency: this.currency,
			vatIncluded: this.vatIncluded
		}
		data.operations = [];
		data.operations.push({
			operator: "MULTIPLY",
			useVatAmount: this.vatIncluded,
			multiplier: this.qty == null ? 1 : this.qty,
			after: "original"
		});
		if (this.discount) {
			data.operations.push({
				operator: "DISCOUNT",
				useVatAmount: this.vatIncluded,
				discount: this.discount,
				after: "discounted"
			});
		}
		if (this.items) {
			data.operations.push({
				operator: "PLUS",
				money: this.items
			});
		}
		if (this.conversion) {
			data.operations.push({
				operator: "CONVERT",
				to: this.conversion
			})
		}
		return data;
	}

	/**
	 * @param {function} listener
	 */
	onRecalc(listener) {
		this.listeners.push(listener);
	}

	fireRecalc(data) {
		for (let lnr of this.listeners) {
			lnr(data);
		}
	}

	/**
	 * @param {string} type
	 * @param {number} value
	 */
	setDiscount(type, value) {
		this.discount = { type, value };
		this.recalc();
	}

	registerVatIncludedCheckbox(id) {
		const that = this;
		const element = $("#"+id);
		if (element.length > 0) {
			const copier = () => that.setVatIncluded(element.is(":checked"));
			element.on("change", copier);
			copier();
			this.changeCopiers.push(copier)
		} else console.log("Conductor: Cannot find element ID=" + id);
	}

	/**
	 * @param {boolean} vatInc
	 */
	setVatIncluded(vatInc) {
		this.vatIncluded = vatInc;
		this.recalc();
	}

	registerUnitAmount(id) {
		const that = this;
		const element = $("#"+id);
		if (element.length > 0) {
			const copier = () => that.setUnitAmount(Money.parse(element.val()));
			element.on("change", copier);
			copier();
			this.changeCopiers.push(copier)
		} else console.log("Conductor: Cannot find element ID=" + id);
	}

	setUnitAmount(amount) {
		this.amount = MoneyEditingConductor.asNumber(amount);
		this.recalc();
	}

	registerLevelSelect(id) {
		const that = this;
		const element = $("#"+id);
		if (element.length > 0) {
			const copier = () => that.setLevel(parseInt(element.val()));
			element.on("change", copier);
			copier();
			this.changeCopiers.push(copier)
		} else console.log("Conductor: Cannot find element ID=" + id);
	}

	setLevel(level) {
		this.level = level;
		this.recalc();
	}

	registerQty(id) {
		const that = this;
		const element = $("#"+id);
		if (element.length > 0) {
			const copier = () => that.setQty(element.val());
			element.on("change", copier);
			copier();
			this.changeCopiers.push(copier)
		} else console.log("Conductor: Cannot find element ID=" + id);
	}

	setQty(qty) {
		this.qty = MoneyEditingConductor.asNumber(qty);
		this.recalc();
	}


	registerCurrencySelect(id) {
		const that = this;
		const element = $("#"+id);
		if (element.length > 0) {
			const copier = () => that.setCurrency(element.val());
			element.on("change", copier);
			copier();
			this.changeCopiers.push(copier)
		} else console.log("Conductor: Cannot find element ID=" + id);
	}

	setCurrency(currency) {
		this.currency = currency;
		this.recalc();
	}

	setConversion(currencyCode) {
		this.conversion = currencyCode;
		this.recalc();
	}

	setTaxDate(td) {
		this.taxDate = td;
		this.recalc();
	}

	/**
	 * Start querying the server to obtain
	 */
	start() {
		if (!this.query) {
			this.query = true;
			this.recalc();
		}
	}

	setItemsMoney(items) {
		this.items = items;
	}

	static asNumber(n) {
		if (typeof n === 'number') return n;
		if (n == null || typeof n === 'undefined') return 0;
		return Money.parse(n.toString());
	}

	static postJSON(obj) {
		return new Promise((resolve, reject) => {
			const data = JSON.stringify(obj);
			try {
				const ops = {
					data: data,
					contentType: 'application/json',
					dataType: "json",
					method: "POST"
				};
				$.ajax("api/services/money/calc", ops)
					.done((data) => {
						resolve(data);
					})
					.fail((jqXHR, textStatus, errorThrown) => {
						console.log("FAIL AJAX "+JSON.stringify(jqXHR)+" ... "+textStatus+" ... "+errorThrown);
						reject(jqXHR);
					});
			} catch (e) {
				console.log("Exception "+e);
				reject(e);
			}
		});
	}
}

// Make default singleton instance for the page
export default new MoneyEditingConductor();